export default {
  EFBST_ACTIVE: 'active',
  EFBST_PLAYED: 'played',
  EFBST_NO_DATA: 'no_data',
  EFBST_EXPIRED: 'expired',
}
